import { render, staticRenderFns } from "./docRepoDownloads.vue?vue&type=template&id=c41ca18c&scoped=true"
import script from "./docRepoDownloads.vue?vue&type=script&lang=js"
export * from "./docRepoDownloads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c41ca18c",
  null
  
)

export default component.exports